var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Volume_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Volume_Icon",
    "data-name": "Volume Icon",
    clipPath: "url(#clip-Volume_Icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-volume-up",
    "data-name": "Icon awesome-volume-up",
    d: "M11.51,4.072,6.748,8.833H1.285A1.284,1.284,0,0,0,0,10.118v7.708a1.285,1.285,0,0,0,1.285,1.285H6.748l4.763,4.761a1.285,1.285,0,0,0,2.193-.908V4.98A1.286,1.286,0,0,0,11.51,4.072ZM24,1.337A1.3,1.3,0,1,0,22.578,3.5a12.507,12.507,0,0,1,0,20.939A1.3,1.3,0,1,0,24,26.607a15.1,15.1,0,0,0,0-25.27Zm1.694,12.635A9.884,9.884,0,0,0,21.1,5.609a1.279,1.279,0,0,0-1.773.4,1.3,1.3,0,0,0,.4,1.786,7.316,7.316,0,0,1,0,12.357,1.3,1.3,0,0,0-.4,1.786,1.282,1.282,0,0,0,1.773.4A9.883,9.883,0,0,0,25.694,13.972ZM18.105,9.857a1.285,1.285,0,0,0-1.24,2.251,2.11,2.11,0,0,1,0,3.727,1.285,1.285,0,0,0,1.24,2.251,4.68,4.68,0,0,0,0-8.23Z",
    transform: "translate(0 -0.472)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.029828e23882902f747ba7bfd36de034.svg";
export { ForwardRef as ReactComponent };